module.exports = __webpack_public_path__ + "img/other.e187c38e.svg";